import _ from 'underscore';
import Base, { baseInit } from './base';

class Kpi extends Base {
  static validations = {
    kpiId(val, kpi) {
      if (!_.isEmpty(kpi.value) && val === null) {
        return new Error('KPI type is required');
      }
      return null;
    },

    value(val, kpi) {
      if (kpi.kpiId !== null && _.isEmpty(val)) {
        return new Error('Value is required');
      }
      return null;
    },
  };

  _uuid = null; // String - internal field used for referencing kpi
  kpiId = null; // Integer
  value = null; // string

  constructor(data) {
    super(data);
    baseInit(this, data, true);
  }

  isEmpty() {
    return _.isEmpty(this.kpiId) && _.isEmpty(this.value);
  }
}

export { Kpi };
